var svgStyles = {
  "root": "SVG-root_1gLEH",
  "fill-green": "SVG-fill-green_3XEHx",
  "fill-blue": "SVG-fill-blue_3XxuW",
  "fill-grey-lighter": "SVG-fill-grey-lighter_ZsArp",
  "fill-grey-light": "SVG-fill-grey-light_2xlhv",
  "fill-grey": "SVG-fill-grey_BVkZ6",
  "fill-grey-dark": "SVG-fill-grey-dark_BCV7H",
  "fill-grey-darker": "SVG-fill-grey-darker_24g8W",
  "fill-anthracite": "SVG-fill-anthracite_7Va6z",
  "fill-yellow": "SVG-fill-yellow_1DmnQ",
  "fill-yellow-dark": "SVG-fill-yellow-dark_oJJ2l",
  "fill-yellow-darker": "SVG-fill-yellow-darker_3Tu8T",
  "fill-red": "SVG-fill-red_1zjVE",
  "fill-unknown": "SVG-fill-unknown_cu2te SVG-fill-grey-dark_BCV7H",
  "fill-info": "SVG-fill-info_dJHzJ",
  "fill-success": "SVG-fill-success_2sUEP",
  "fill-warning": "SVG-fill-warning_3l7NA",
  "fill-danger": "SVG-fill-danger_3h58E",
  "fill-progress": "SVG-fill-progress_1wmR1 SVG-fill-info_dJHzJ",
  "fill-white": "SVG-fill-white_1ifIm",
  "fill-accent": "SVG-fill-accent_hrCaj",
  "fill-neutral-weak": "SVG-fill-neutral-weak_RUQEU",
  "fill-neutral-plain": "SVG-fill-neutral-plain_3jzV-",
  "fill-neutral-strong": "SVG-fill-neutral-strong_2iDzN",
  "fill-disabled": "SVG-fill-disabled_2Wv9a",
  "fill-informative": "SVG-fill-informative_2TJ7Q",
  "fill-positive": "SVG-fill-positive_A2UHl",
  "fill-notice": "SVG-fill-notice_99WSg",
  "fill-negative": "SVG-fill-negative_2JTXR"
};
import Svg from '../../Svg';
import Widget from '../Widget';
import { jsx as _jsx } from "react/jsx-runtime";
function Icon({
  name,
  theme,
  title,
  id,
  ...extraProps
}) {
  return /*#__PURE__*/_jsx(Widget, {
    tagName: "span",
    flex: true,
    flexShrink0: true,
    placeItemsCenter: true,
    widgetFluidHeight: true,
    ...extraProps,
    children: /*#__PURE__*/_jsx(Svg, {
      name: name,
      title: title,
      id: id,
      theme: theme,
      className: svgStyles.root
    })
  });
}
export default Icon;